// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'

/**
 * 后台埋点日志收容
 */
export function logTakeIn(data = {}) {
  return request({
    url: '/admin/v1/common/log/pc/event',
    method: 'post',
    data,
  })
}

/**
 * @apiName 获取当前租户的logo
 * @apiUrl /v1/manage/resource/getResourceByToken
 */
export function getTenantLogo() {
  return Promise.resolve({
    code: 1,
    data: null,
  })
}

/**
 * @apiName 获取当前用户的资源权限(精简返回字段接口)
 */
export function getResourceByTokenV2(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/resource/tree/V2',
    method: 'post',
    data,
  })
}


// 问题反馈
export function problemsFeedback(data = {}) {
  return request({
    url: '/admin/v1/vehicle/feedback/add',
    method: 'post',
    data,
  })
}

// 获取提交钉钉审批按钮显示/隐藏状态接口
export function getSubmitDingTalkShow(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTemplate/getState',
    method: 'post',
    data,
  })
}

/** 枚举通用接口 */
export function getEnum(data = {}) {
  return request({
    url: '/admin/v1/vehicle/state/enum',
    method: 'post',
    data,
  })
}

// 获取维修厂或服务商列表
export function providerList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}

// 检查租户所在公司是否开通服务
export function checkConfigState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/common/config/getState',
    method: 'POST',
    data,
  })
}

// 查询省份
export function areaList(data) {
  return request({
    url: '/admin/v1/vehicle/platform/provinces/list',
    method: 'POST',
    data,
  })
}

// 根据省份查询城市
export function provinceCityList(data) {
  return request({
    url: '/admin/v1/vehicle/platform/city/list',
    method: 'POST',
    data,
  })
}

// 根据城市adcode码获取具体地址
export function addrList(data) {
  return request({
    url: '/admin/v1/vehicle/region/addrList',
    method: 'POST',
    data,
  })
}

// 判断集团是否灰度放量
export function checkGrayTenant(data) {
  return request({
    url: '/admin/v1/vehicle/common/checkGrayTenant',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 省市区
 */
export function getRegions(data = {}) {
  return request({
    url: '/admin/v1/maintenance/purchase/province/list',
    method: 'POST',
    data,
  })
}

/**
 * 获取隐私标志
 */
export function getPrivacyFlag() {
  return request({
    url: '/admin/v1/vehicle/user/manage/sensitive/getState',
    method: 'post',
    data: {},
  })
}

/**
 * 更新隐私标志
 * @param {boolean} state - 隐私状态，0：关；1：开
 */
export function updatePrivacyFlag(state) {
  return request({
    url: '/admin/v1/vehicle/user/manage/sensitive/saveState',
    method: 'post',
    data: { state },
  })
}

// 安全检测
export const checkTextSafe = (data = {}) => {
  return request({
    url: '/admin/v1/vehicle/safety/textScan',
    method: 'POST',
    data,
  })
}
